(function () {
  'use strict';

  angular
    .module('web2print.sidebar.myorder')
    .directive('sidebarMyorder', sidebarMyOrder);

  /* @ngInject */
  function sidebarMyOrder () {
    const directive = {
      restrict: 'E',
      templateUrl: 'components/sidebar/my-order/sidebar-my-order.directive.html',
      scope: {
        'landingSelection': '@' // change this to '=' when we already have dynamic data for the selection
      },
      controller: 'SidebarMyOrderController',
      controllerAs: 'ctrl',
      bindToController: true
    };
    return directive;
  }
})();
